<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración de Tipos de Movimientos</li>
</ol>

<h1 class="page-header"><i class="fas fa-tachometer-alt"></i> Administración de Tipos de Movimientos</h1>

<panel [noButton]="true">
    <div class="row">
        <div class="d-flex justify-content-end pr-5">
            <button class="btn btn-primary btn-sm" (click)="open(modalTypeForm)">Nuevo Tipo Movimiento</button>
        </div>
    </div>
    <div class="row">
        <div class="table-responsive">
        <table class="table table-sm table-striped table-hover my-5">
            <thead>
                <tr>
                    <th class="text-center">N°</th>
                    <th>Nombre</th>
                    <th class="text-center">Habilitado</th>
                    <th class="text-center"><i class="fas fa-cogs"></i></th>
                </tr>
            </thead>
            <tbody>
                @for(type of types; track $index){
                <tr>
                    <td class="text-center">{{ $index + 1 }}</td>
                    <td>{{ type.name }}</td>
                    <td>
                        <div class="form-check form-switch d-flex justify-content-center">
                            <input class="form-check-input" type="checkbox" id="checkbox1" [checked]="type.enabled" (change)="enabledType(type)"/>
                        </div>
                    </td>
                    <td class="text-center">
                        <button class="btn btn-xs btn-primary mx-2" (click)="open(modalTypeForm, type)"
                            ngbTooltip="Revisar Evaluación"><i class="fas fa-eye"></i></button>
                        
                    </td>


                </tr>
                }
                @empty{
                <tr>
                    <td colspan="6" class="text-center">No hay registros</td>
                </tr>

                }
            </tbody>
        </table>
        </div>
    </div>
</panel>


<ng-template #modalTypeForm let-c="close" let-d="dismiss">

    <div class="modal-header">
        <span class="fs-3 fw-700">Tipos de Movimiento</span>
    </div>
    <div class="modal-body" [formGroup]="newTypeForm">
        <div class="row mb-3">

            <div class="col-md-6">
                <label class="form-label col-form-label col-md-3">Nombre</label>
                <input type="text" class="form-control" placeholder="Nombre" formControlName="name" />
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
        <button class="btn btn-primary" (click)="d('Cross click'); saveType()">Guardar</button>
    </div>
</ng-template>